module.exports = "<div class=\"vc-profile-icon\">\n    <sds-icon size=\"24\" name=\"user\"></sds-icon>\n</div>\n<video class=\"vc-video\" #video></video>\n";